/* import __COLOCATED_TEMPLATE__ from './popover.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { createPopper } from '@popperjs/core';
import { run } from '@ember/runloop';
const HIT_AREA_SPACING_CLASSES = {
  4: {
    left: 'pr-4',
    right: 'pl-4',
    top: 'pb-4',
    bottom: 'pt-4'
  }
};
export const POPOVER_CONTAINER_CLASS = 'prosemirror-composer-popover-container';
let Popover = (_class = class Popover extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "popper", void 0);
    _defineProperty(this, "offset", this.args.offset || [0, 5]);
  }
  get popoverContainerClass() {
    if (this.args.cssClass) {
      return `${POPOVER_CONTAINER_CLASS} ${this.args.cssClass}`;
    }
    return POPOVER_CONTAINER_CLASS;
  }
  get renderContext() {
    if (!this.args.renderInPlace) {
      return document.querySelector('.ember-application');
    }
    return null;
  }
  get virtualElement() {
    return {
      getBoundingClientRect: () => {
        return this.args.rect;
      }
    };
  }
  get placement() {
    return this.args.placement ?? 'left';
  }
  get hitAreaClass() {
    let hitAreaClasses = HIT_AREA_SPACING_CLASSES[this.args.hitAreaSize];
    if (!hitAreaClasses) {
      return '';
    }
    if (this.placement.startsWith('left')) {
      return hitAreaClasses.left;
    } else if (this.placement.startsWith('right')) {
      return hitAreaClasses.right;
    } else if (this.placement.startsWith('top')) {
      return hitAreaClasses.top;
    } else if (this.placement.startsWith('bottom')) {
      return hitAreaClasses.bottom;
    }
    return '';
  }
  createPopper(popoverElement) {
    let modifiers = [{
      name: 'offset',
      options: {
        offset: this.offset
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        boundary: this.args.clippingElement ?? 'clippingParents',
        altAxis: !!this.args.renderOverEditor
      }
    }, {
      name: 'flip',
      enabled: !this.args.renderOverEditor
    }];
    let popperOptions = {
      placement: this.placement,
      modifiers
    };
    this.popper = createPopper(this.virtualElement, popoverElement, popperOptions);
    this.repositionPopper();
  }
  repositionPopper() {
    if (!this.isDestroying) {
      run(() => {
        this.popper?.update();
      });
    }
  }
  willDestroy() {
    this.popper?.destroy();
    super.willDestroy();
  }
}, _applyDecoratedDescriptor(_class.prototype, "createPopper", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createPopper"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "repositionPopper", [action], Object.getOwnPropertyDescriptor(_class.prototype, "repositionPopper"), _class.prototype), _class);
export { Popover as default };